export interface Collection {
  id: string;
  name: string;
  subtitle: string;
  desc: string;
  topic: string[];
  cover: string;
  coverAlt: string;
}

export const collections: Collection[] = [
  {
    id: "featured",
    name: "热门大瓜盘点",
    subtitle: "全网最热话题，一键归档",
    desc: "把近期讨论度最高、转发最猛的热点话题按时间线归档整理，蹲后续的朋友不用再到处翻，点开这里就能从头看起。",
    topic: ["要闻", "实时", "热榜"],
    cover: "https://readdy.ai/api/search-image?query=stack%20of%20trending%20news%20clippings%20and%20warm%20paper%20cards%20with%20red%20tape%20marks%20on%20wooden%20table%2C%20editorial%20collage%2C%20warm%20coral%20cream%20and%20ink%20tones%2C%20magazine%20layout&width=800&height=520&seq=col-featured-01&orientation=landscape",
    coverAlt: "整理归档的热点话题纸片合集"
  },
  {
    id: "variety",
    name: "综艺前线",
    subtitle: "新综艺与名场面速递",
    desc: "新开播的综艺、让人反复回味的爆款名场面、嘉宾之间的高光与意难平，关于综艺的一切新鲜事都收在这里。",
    topic: ["综艺", "真人秀", "名场面"],
    cover: "https://readdy.ai/api/search-image?query=colorful%20television%20studio%20stage%20with%20bright%20colorful%20lighting%20and%20camera%20equipment%2C%20warm%20coral%20tones%2C%20editorial%20broadcast%20style%2C%20energetic&width=800&height=520&seq=col-variety-02&orientation=landscape",
    coverAlt: "综艺演播厅彩色灯光舞台"
  },
  {
    id: "stage",
    name: "演出与舞台",
    subtitle: "演唱会、音乐节与现场瞬间",
    desc: "开票日历、巡演资讯、现场名场面与演出市场观察。爱看现场的人，总会在这里找到下一场奔赴的理由。",
    topic: ["演出", "演唱会", "音乐节"],
    cover: "https://readdy.ai/api/search-image?query=music%20festival%20stage%20with%20silhouette%20crowd%20and%20colorful%20stage%20lights%20at%20dusk%2C%20warm%20coral%20and%20deep%20red%20sky%2C%20editorial%20concert%20photography%2C%20atmospheric&width=800&height=520&seq=col-stage-03&orientation=landscape",
    coverAlt: "音乐节黄昏舞台与人群剪影"
  },
  {
    id: "industry",
    name: "内容产业观察",
    subtitle: "看热闹，也看门道",
    desc: "短剧、影视、直播与平台新玩法。在这里，我们不只吃瓜，也试着拆解内容行业每一条热点背后的商业逻辑与行业风向。",
    topic: ["产业", "短剧", "行业"],
    cover: "https://readdy.ai/api/search-image?query=minimal%20editorial%20desk%20scene%20with%20charts%20reports%20and%20open%20notebook%2C%20warm%20cream%20and%20coffee%20tones%2C%20modern%20business%20magazine%20photography&width=800&height=520&seq=col-industry-04&orientation=landscape",
    coverAlt: "内容产业分析报告与图表桌景"
  },
  {
    id: "fans",
    name: "粉丝与饭圈文化",
    subtitle: "关于热爱与边界感的讨论",
    desc: "应援、打投、公益与饭圈百态。这一专栏想认真聊聊年轻人为热爱奔走的故事，也聊聊热情与理性之间的分寸。",
    topic: ["粉丝", "饭圈", "应援"],
    cover: "https://readdy.ai/api/search-image?query=soft%20glowing%20lightsticks%20and%20handwritten%20fan%20letters%20on%20warm%20desk%2C%20warm%20coral%20and%20cream%20tones%2C%20heartfelt%20editorial%20photography%2C%20cozy%20atmosphere&width=800&height=520&seq=col-fans-05&orientation=landscape",
    coverAlt: "暖色桌面上的荧光棒与手写信"
  }
];